// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as BarChartLDefault } from '../../../assets/icons/default/charts/bar-chart-l.svg?react';
import { ReactComponent as BarChartLSolid } from '../../../assets/icons/solid/charts/BAR-CHART-L.svg?react';
import { createIcons } from '../../Icon';
const BarChartLIcon = /* @__PURE__ */ createIcons('BarChartL', {
    default: BarChartLDefault,
    solid: BarChartLSolid
});
BarChartLIcon.supportedTypes = ['default', 'solid'];
BarChartLIcon.category = 'charts';
export default BarChartLIcon;
